import { useSyncExternalStore } from 'react'
import { Link } from 'react-router-dom'

import { KindLumenInline } from '@/components/brand/kindlumen'
import { footerColumns, legalLinks } from '@/data/marketing'
import { setAnalyticsConsent } from '@/lib/analytics/acquisition'

// The site is prerendered at build time. Rendering the visitor's year directly
// would mismatch the HTML once the year rolls over; this hydrates with the
// build year and then switches to the real one.
const subscribeNoop = () => () => {}

export function SiteFooter() {
  const year = useSyncExternalStore(subscribeNoop, () => new Date().getFullYear(), () => __BUILD_YEAR__)
  return (
    <footer className="bg-night text-white">
      <div className="marketing-shell grid gap-10 py-16 lg:grid-cols-[minmax(0,1.55fr)_repeat(3,minmax(0,0.78fr))]">
        <div className="space-y-4">
          <div className="inline-flex rounded-full border border-white/10 bg-white/10 px-3 py-1 text-xs font-semibold text-white/70">
            <KindLumenInline tone="inverse" />
          </div>
          <h2 className="max-w-[31rem] text-2xl font-semibold leading-[1.18] text-white">
            The Stripe-powered donation form for nonprofit websites.
          </h2>
          <p className="max-w-[32rem] text-sm leading-6 text-white/55">
            Create a branded one-time and recurring donation form, connect your own Stripe account, and embed it on the website you already have.
          </p>
        </div>

        {footerColumns.map((column) => (
          <div key={column.title} className="space-y-4">
            <h3 className="text-sm font-semibold uppercase tracking-[0.18em] text-white/40">
              {column.title}
            </h3>
            <div className="space-y-3 text-sm text-white/60">
              {column.links.map((link) => (
                <div key={link.href}>
                  <Link to={link.href} className="transition hover:text-white">
                    {link.label}
                  </Link>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      <div className="border-t border-white/10">
        <div className="marketing-shell flex flex-col gap-4 py-5 text-sm text-white/40 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} KindLumen. All rights reserved.</p>
          <nav className="flex flex-wrap items-center gap-x-6 gap-y-2" aria-label="Legal">
            <button type="button" className="transition hover:text-white" onClick={() => setAnalyticsConsent(null)}>Analytics preferences</button>
            {legalLinks.map((link) => (
              <Link key={link.href} to={link.href} className="transition hover:text-white">
                {link.label}
              </Link>
            ))}
          </nav>
        </div>
      </div>
    </footer>
  )
}
